import { render, staticRenderFns } from "./MSecondaryTips.vue?vue&type=template&id=54bb0c80&"
import script from "./MSecondaryTips.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryTips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports